import {Button as ButtonPrimitive} from "@base-ui/react/button"
import {cva, type VariantProps} from "class-variance-authority"
import {clsx} from "clsx"

const buttonVariants = cva("btn", {
	variants: {
		variant: {
			primary: "btn-primary",
			outline: "btn-outline-primary-bg",
			destructive: "btn-danger",
			destructiveOutline: "btn-outline-danger",
			secondary: "btn-default",
			info: "btn-secondary",
			success: "btn-success",
			link: "btn-link",
		},
		size: {
			default: "",
			sm: "btn-sm",
			lg: "btn-lg",
		},
	},
	defaultVariants: {
		variant: "primary",
		size: "default",
	},
})

type ButtonVariants = VariantProps<typeof buttonVariants>

function Button({
					className,
					variant = "primary",
					size = "default",
					...props
				}: ButtonPrimitive.Props & ButtonVariants) {
	return (
		<ButtonPrimitive
			data-slot="button"
			className={clsx(buttonVariants({variant, size}), className)}
			{...props}
		/>
	)
}

export {Button, buttonVariants}
export type {ButtonVariants}
